export enum FrontendMessageType {
    info = info,
    success = "success",
    warning = "warning",
    error = "error",
}
